<template>
  <div class="content-list">
    <heading
      v-if="hasTitle"
      :tagField="headingSize"
      :textField="title"
      :class="['title', {'title-editor': isEditMode}, themeClass]"
    />
    <div class="content-list-link" :class="{'link-editor': isEditMode}">
      <sc-link v-if="isEditMode" :field="link"/>
      <sh-button v-else
        :naked="true"
        :href="linkHref"
        :target="linkTarget"
        :aria-label="linkText"
      >
        {{ linkText }}
      </sh-button>
    </div>
    <template v-if="!isEditMode" v-for="tile in tiles">
      <component :key="tile.id" :is="tile.value"/>
    </template>
    <sc-placeholder v-if="isEditMode" class="content-list-editor" :rendering="rendering" name="digital-house-content-list" />
  </div>
</template>

<script>

import { Placeholder, Text, Link } from '@sitecore-jss/sitecore-jss-vue'
import { createNamespacedHelpers } from 'vuex'
import mapFields from '~/helpers/map-fields'
import { arrayUID } from '~/helpers/unique-id'
import { decreaseTagValue } from '~/helpers/decrease-tag-value'
import ScRender from '../sc-render/'
import ContentListTile from '../content-list-tile/index'
import Heading from '../heading'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')
const { mapGetters: mapEnvGetters } = createNamespacedHelpers('ui/environment')

export default {
  name: 'ContentList',
  props: {
    fields: {
      type: Object,
      default: () => ({})
    },
    rendering: {
      type: Object
    }
  },
  components: {
    ContentListTile,
    ScRender,
    ScPlaceholder: Placeholder,
    ScText: Text,
    ScLink: Link,
    Heading
  },
  withPlaceholder () {
    return {
      placeholders: [
        {
          placeholder: 'digital-house-content-list',
          computedPropName: 'placeholderTiles'
        }
      ]
    }
  },
  computed: {
    ...mapJssGetters(['isEditMode', 'colorTheme']),
    ...mapEnvGetters(['isDarkTheme']),
    ...mapFields({
      link: 'link',
      linkHref: 'link.value.href',
      linkTarget: 'link.value.target',
      linkText: 'link.value.text',
      title: 'title',
      titleValue: 'title.value',
      headingSize: 'headingSize'
    }),
    tiles () {
      return arrayUID(this.placeholderTiles)
    },
    hasTitle () {
      return this.isEditMode || this.titleValue
    },

    themeClass () {
      return `theme-${this.colorTheme}`.toLowerCase()
    },

    tileHeadingSize () {
      return decreaseTagValue(this.headingSize)
    }
  }
}
</script>

<style lang="scss" scoped>

.content-list {
  max-width: 100%;
  margin: $space-080 $space-060 0;
    @include tablet {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      flex-wrap: wrap;
      flex: 1 1 auto;
    }

  .content-list-tile {
    @include tablet {
      margin: 0 1% $space-100 0;
      width: 24%;
    }
  }
}

.content-list-editor {
  width: 100%;
  display: flex;
  margin: 0 $space-050;
}

.title {
  @include font("040");
    margin: $space-030 0;
    @include tablet {
      display: none;
    }
}

.title-editor {
  @include tablet {
    display: block;
    width: 100%;
  }
}

.content-list-link {
  margin: $space-040 0;
  @include tablet {
    display: none;
  }
}

.link-editor {
  @include tablet {
    display: block;
    width: 100%;
  }
}

.theme-black {
  a {
    color: $color-white;
  }
}
</style>
